import {useTheme} from '../Tools/Themes';
import React, {Component} from 'react';
import {Text, Linking, ScrollView} from 'react-native';
import styled, {css} from 'styled-components/native';
import {colours, spacing} from '../styles/Style';
import {GetGlobalTheme, IsHRWeb} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import Requests from '../api/Requests';
import LanguageSelect from '../components/status/LanguageSelect';
import {Dimensions} from 'react-native';

const ForgotPasswordWrap = styled.View`
  ${(IsHRWeb() &&
    css`
      position: relative;
      height: 100vh;
    `) ||
  css`
    height: 100%;
    justify-content: center;
  `}
  width: 100%;
  background-color: ${colours[GetGlobalTheme()].mainBackground};
`;

const ForgotAction = styled.View`
  width: 100%;
  ${(IsHRWeb() &&
    css`
      flex-direction: row;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

const LoginForm = styled.View`
  margin: 0 auto;
  ${(IsHRWeb() &&
    css`
      position: absolute;
      width: 300px;
      top: 50%;
      margin-top: -170px;
      left: 50%;
      margin-left: -150px;
    `) ||
  css`
    max-width: ${Dimensions.get('window').width > 400
      ? '400px'
      : Dimensions.get('window').width};
    width: 100%;
    position: absolute;
    top: 50%;
    margin-top: -200px;
    left: 50%;
    margin-left: -${Dimensions.get('window').width > 400 ? '200px' : Dimensions.get('window').width / 2};
  `}
  padding: 20px;
  background: ${colours[GetGlobalTheme()].navigationBackground};
  border-radius: 6px;
`;

export class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.SendForgotPassword = this.SendForgotPassword.bind(this);
    this.state = {
      email: '',
    };
  }

  SendForgotPassword = () => {
    if (this.state.email !== '') {
      Requests.ResetPassword(this.state.email)
        .then((response) => {
          if (response.msg == 'notfound') {
            alert(translate('Reset_UserNotFound'));
          } else {
            alert(translate('Reset_CheckEmail'));
            global.updateLoginStatus(2);
          }
        })
        .catch((error) => {});
    }
  };

  render() {
    let self = this;
    return (
      <ForgotPasswordWrap>
        <LoginForm>
          <ScrollView
            contentContainerStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <EditField
              title={translate('Email')}
              value={this.state.email}
              width="100%"
              name={'username'}
              inputStyle={{
                backgroundColor: colours[GetGlobalTheme()].inputBackground,
              }}
              onChange={(index, fn, value) => {
                self.setState({email: value});
              }}
            />
            <ForgotAction>
              <ActionButton
                onPress={() => {
                  global.updateLoginStatus(2);
                }}
                style={{width: IsHRWeb() ? null : '96%'}}
                title={translate('Cancel')}
              />
              <ActionButton
                onPress={() => {
                  self.SendForgotPassword();
                }}
                style={{width: IsHRWeb() ? null : '96%'}}
                title={translate('Send')}
              />
            </ForgotAction>
          </ScrollView>
        </LoginForm>
      </ForgotPasswordWrap>
    );
  }
}
